import styled from 'styled-components';
import { Flex, token } from '@bynder/design-system';

export const StyledFlex = styled(Flex)`
    overflow-x: scroll;
    width: 100%;
    padding: ${token.spacing2};
`;
